import React, { useState } from 'react';

// Assume you have these components or image imports
// For demonstration, let's create a placeholder logo component
const PlaceholderLogo = ({ name }) => (
  <div style={{
    width: '100%',
    height: '30px',
    backgroundColor: '#f0f0f0',
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    color: '#999'
  }}>
    {name}
  </div>
);


// Your settings object to control logo visibility
const settings = {
    showLogos: true, // You can control this with a prop or state
};




const BrandImageryVisualization = ({ data,logoMap,page }) => {
  const [selectedAttribute, setSelectedAttribute] = useState(0);
  const [hoverInfo, setHoverInfo] = useState(null);

  const attributes = [...new Set(data.flatMap(brand => brand.funnelData.map(item => item.catlabel)))];

  const labels =page=='imagery'? ["Strongly agree", "Somewhat agree", "Neither agree nor disagree", "Somewhat Disagree", "Strongly Disagree"]: ["Strongly agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"];







  // The function to get the logo component
const getLogoComponent = (logoName) => {
    if (!settings.showLogos) return null;
    
    // Check if the logo exists in the map, otherwise show a placeholder
    return logoMap[logoName] || <PlaceholderLogo name={logoName} />;
};
  const colorPalette = {
    "Strongly agree": "#27ae60",
    "Somewhat agree": "#2ecc71",
    "Neither agree nor disagree": "#f1c40f",
    "Somewhat Disagree": "#e67e22",
    "Strongly Disagree": "#e74c3c",
    "Strongly agree": "#27ae60",
    "Agree": "#2ecc71",
    "Neutral": "#f1c40f",
    "Disagree": "#e67e22",
    "Strongly Disagree": "#e74c3c"
  };

  const calculateTop2Box = (brandData, attribute) => {
    const filteredData = brandData.funnelData.filter(item =>
      item.catlabel === attribute &&
      (item.label === "Strongly agree" || item.label === "Somewhat agree")
    );
    return filteredData.reduce((sum, item) => sum + item.percentage, 0);
  };

  const getBrandDataForAttribute = (brand, attribute) => {
    return labels.map(label => {
      const itemData = brand.funnelData.find(item =>
        item.catlabel === attribute && item.label === label
      );
      return itemData ? itemData.percentage : 0;
    });
  };

  const maxPercentage = Math.max(...data.map(brand => {
    const brandData = getBrandDataForAttribute(brand, attributes[selectedAttribute]);
    return brandData.reduce((sum, value) => sum + value, 0);
  }));

  return (
    <div style={{
      padding: '24px',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
      maxWidth: '1200px',
      margin: '0 auto',
      backgroundColor: '#f8fafc',
      minHeight: '100vh'
    }}>

      {/* Attribute Selection */}
      {attributes.length>1 && <div style={{
        backgroundColor: 'white',
        padding: '24px',
        borderRadius: '16px',
        marginBottom: '24px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        border: '1px solid #e2e8f0'
      }}>
        <h3 style={{
          color: '#1e293b',
          margin: '0 0 16px 0',
          fontSize: '18px',
          fontWeight: '600'
        }}>Select Attribute:</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
          {attributes.map((attribute, index) => (
            <button
              key={index}
              onClick={() => setSelectedAttribute(index)}
              style={{
                padding: '12px 20px',
                borderRadius: '8px',
                border: 'none',
                backgroundColor: index === selectedAttribute ? '#3b82f6' : '#f1f5f9',
                color: index === selectedAttribute ? 'white' : '#64748b',
                cursor: 'pointer',
                fontWeight: '500',
                transition: 'all 0.2s ease',
                fontSize: '14px',
                minWidth: '180px',
                boxShadow: index === selectedAttribute ? '0 4px 6px rgba(59, 130, 246, 0.3)' : 'none'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = index === selectedAttribute ? '#2563eb' : '#e2e8f0';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = index === selectedAttribute ? '#3b82f6' : '#f1f5f9';
              }}
            >
              {attribute.replace('Brand Imagery: ', '')}
            </button>
          ))}
        </div>
      </div>}

      {/* Combined Stacked Bar Chart */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '32px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        marginBottom: '30px',
        border: '1px solid #e2e8f0'
      }}>
        <h2 style={{
          color: '#1e293b',
          margin: '0 0 64px 0',
          textAlign: 'center',
          fontSize: '24px',
          fontWeight: '700'
        }}>
          {attributes[selectedAttribute]?.replace('Brand Imagery: ', '') || 'Select an attribute'}
        </h2>

        <div style={{
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'flex-end',
          height: '360px',
          position: 'relative',
          padding: '40px 20px 0',
          marginBottom: '40px'
        }}>
          {/* Y-axis labels */}
          {/* Y-axis labels */}
{/* Top 2 Box Label */}
<div style={{
  position: 'absolute',
  left: '0',
  top: '-28px',
  fontSize: '14px',
  fontWeight: '600',
  color: '#1e293b'
}}>
  Top 2 Box
</div>

          <div style={{
            position: 'absolute',
            left: '0',
            top: '0',
            bottom: '0',
            width: '40px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: '10px 0'
          }}>
            {[0, 25, 50, 75, 100].map(value => (
              <div key={value} style={{
                fontSize: '12px',
                color: '#94a3b8',
                textAlign: 'right',
                paddingRight: '8px'
              }}>
                {value}%
              </div>
            ))}
          </div>

          {/* Chart content */}
          <div style={{
            position: 'absolute',
            left: '48px',
            right: '0',
            top: '0',
            bottom: '0',
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'flex-end'
          }}>
            {data.map((brand, brandIndex) => {
              const brandData = getBrandDataForAttribute(brand, attributes[selectedAttribute]);
              const top2BoxScore = calculateTop2Box(brand, attributes[selectedAttribute]);

              return (
                <div key={brandIndex} style={{
                  width: '100px',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  position: 'relative'
                }}>
                  {/* Top 2 Box Score */}
                  <div style={{
                    position: 'absolute',
                    top: '-48px',
                    left: '0',
                    right: '0',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: '18px',
                    color: '#1e293b',
                    backgroundColor: 'white',
                    padding: '8px 12px',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    border: '1px solid #e2e8f0'
                  }}>
                    {top2BoxScore.toFixed(1)}%
                  </div>

                  {/* Stacked Bar */}
<div style={{
  width: '80px',
  height: `${(brandData.reduce((sum, val) => sum + val, 0) / maxPercentage) * 100}%`,
  display: 'flex',
  flexDirection: 'column',   // ✅ changed from column-reverse
  borderRadius: '8px 8px 0 0',
  overflow: 'hidden',
  boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
  cursor: 'pointer'
}}>
  {brandData.map((percentage, labelIndex) => (
    <div
      key={labelIndex}
      style={{
        height: `${percentage}%`,
        backgroundColor: colorPalette[labels[labelIndex]],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: percentage > 5 ? '12px' : '0',
        color: 'white',
        fontWeight: '600',
        transition: 'all 0.2s ease',
        position: 'relative',
        textShadow: '0 1px 2px rgba(0,0,0,0.5)'
      }}
      onMouseEnter={() => setHoverInfo({
        brand: brand.name,
        label: labels[labelIndex],
        percentage,
        index: labelIndex
      })}
      onMouseLeave={() => setHoverInfo(null)}
    >
      {percentage > 0 && `${percentage.toFixed(1)}%`}
      {hoverInfo && hoverInfo.brand === brand.name && hoverInfo.index === labelIndex && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '100%',
          transform: 'translateY(-50%)',
          marginLeft: '8px',
          padding: '8px 12px',
          backgroundColor: 'white',
          borderRadius: '6px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          zIndex: 10,
          whiteSpace: 'nowrap',
          fontSize: '14px',
          fontWeight: '600',
          color: '#1e293b',
          border: '1px solid #e2e8f0'
        }}>
          {labels[labelIndex]}: {percentage.toFixed(1)}%
        </div>
      )}
    </div>
  ))}
</div>


                  {/* Brand Logo/Name */}
                  <div style={{
                    marginTop: '16px',
                    textAlign: 'center',
                    fontWeight: '700',
                    color: '#1e293b',
                    fontSize: '16px'
                  }}>
                    {/* Replaced brand.name with the logo component */}
                    {getLogoComponent(brand.name)}
                    {getLogoComponent(brand.logo)}
                  </div>

                  {/* Base Size */}
                  <div style={{
                    fontSize: '14px',
                    color: '#64748b',
                    textAlign: 'center',
                    marginTop: '8px'
                  }}>
                    n={brand.funnelData.find(item => item.catlabel === attributes[selectedAttribute])?.Base || 0}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Chart Legend */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '24px',
          marginTop: '32px',
          paddingTop: '24px',
          borderTop: '1px solid #e2e8f0'
        }}>
          {labels.map((label, index) => (
            <div key={index} style={{
              display: 'flex',
              alignItems: 'center',
              padding: '8px 16px',
              backgroundColor: '#f8fafc',
              borderRadius: '8px'
            }}>
              <div style={{
                width: '20px',
                height: '20px',
                backgroundColor: colorPalette[label],
                marginRight: '12px',
                borderRadius: '4px'
              }}></div>
              <span style={{ fontSize: '14px', color: '#475569', fontWeight: '500' }}>{label}</span>
            </div>
          ))}
        </div>
      </div>
      
    </div>
  );
};

export default BrandImageryVisualization;